module.exports = __webpack_public_path__ + "static/media/class_job_026.fecaa7d5.svg";